var _rect, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 88,
    height: 88,
    rx: 22,
    fill: "#FF965D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3859)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#E31D93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4231 33.3333C53.4231 38.488 49.2042 42.6667 44 42.6667C38.7958 42.6667 34.5769 38.488 34.5769 33.3333C34.5769 28.1787 38.7958 24 44 24C49.2042 24 53.4231 28.1787 53.4231 33.3333Z",
    fill: "#E31D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 59.5556C26.5 51.7008 32.6151 45.3333 40.1585 45.3333H47.8415C55.3849 45.3333 61.5 51.7008 61.5 59.5556C61.5 62.0102 59.589 64 57.2317 64H30.7683C28.411 64 26.5 62.0102 26.5 59.5556Z",
    fill: "#E31D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/icUser.fa3048903550c07955f1004aa4380566.svg";
export { ForwardRef as ReactComponent };